var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06202 12.3484C1.97868 12.1238 1.97868 11.8769 2.06202 11.6524C2.87372 9.68421 4.25153 8.0014 6.02079 6.81726C7.79004 5.63312 9.87106 5.00098 12 5.00098C14.129 5.00098 16.21 5.63312 17.9792 6.81726C19.7485 8.0014 21.1263 9.68421 21.938 11.6524C22.0214 11.8769 22.0214 12.1238 21.938 12.3484C21.1263 14.3165 19.7485 15.9993 17.9792 17.1835C16.21 18.3676 14.129 18.9997 12 18.9997C9.87106 18.9997 7.79004 18.3676 6.02079 17.1835C4.25153 15.9993 2.87372 14.3165 2.06202 12.3484Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5cb4245ef06e31fbe8d8cf4186dd6266.svg";
export { ForwardRef as ReactComponent };